// Generated by purs version 0.13.8
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Lens_Internal_Market = require("../Data.Lens.Internal.Market/index.js");
var Data_Lens_Prism = require("../Data.Lens.Prism/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Lunarbox_Data_Class_GraphRep = require("../Lunarbox.Data.Class.GraphRep/index.js");
var Lunarbox_Data_Editor_DataflowFunction = require("../Lunarbox.Data.Editor.DataflowFunction/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Project = require("../Lunarbox.Data.Editor.Project/index.js");
var Lunarbox_Data_Graph = require("../Lunarbox.Data.Graph/index.js");
var describe = function (currentFunction) {
    return function (v) {
        return Data_Function.flip(Data_Map_Internal.mapMaybeWithKey(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(v.functions)(function (name) {
            return function ($$function) {
                var wouldCycle = Lunarbox_Data_Graph.wouldCreateLongCycle(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(name)(currentFunction)(Lunarbox_Data_Class_GraphRep.toGraph(Lunarbox_Data_Editor_Project.graphRepProject)(v));
                var isVisual = Data_Lens_Prism.is(Data_HeytingAlgebra.heytingAlgebraBoolean)(Lunarbox_Data_Editor_DataflowFunction["_VisualFunction"](Data_Lens_Internal_Market.choiceMarket))($$function);
                var isCurrent = Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(currentFunction)(name);
                var isEditable = !isCurrent && (!false && isVisual);
                var isUsable = isCurrent || !wouldCycle;
                var canBeDeleted = isVisual && Data_Eq.notEq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(v.main)(name);
                return new Data_Maybe.Just({
                    isUsable: isUsable,
                    isEditable: isEditable,
                    canBeDeleted: canBeDeleted
                });
            };
        });
    };
};
var onlyEditable = function (c) {
    return function (p) {
        return Data_Map_Internal.filter(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(function (v) {
            return v.isEditable;
        })(describe(c)(p));
    };
};
module.exports = {
    describe: describe,
    onlyEditable: onlyEditable
};
